export const configConstants = {

    FETCH_APPCONFIGS_REQUEST: 'FETCH_APPCONFIGS_REQUEST',
    FETCH_APPCONFIGS_SUCCESS: 'FETCH_APPCONFIGS_SUCCESS',
    FETCH_APPCONFIGS_FAILURE: 'FETCH_APPCONFIGS_FAILURE',

}